module.exports = __webpack_public_path__ + "resources/dialog_celebrate_icon.40b645d91f7aa50b.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/dialog/img/dialog_celebrate_icon.png
// module id = 498
// module chunks = 0 1 2 3 4